import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import moment from 'moment';
import { ModalHeader, ModalBody } from '../modal-helpers';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import './ConnectedPageErrorModal.scss';

const onLocalClose = ({ onClose }) => () => {
  onClose();
}

const onLocalDisconnect = ({ disconnect, onClose, data: { connected_page_id: id } }) => () => {
  disconnect(id);
  onClose();
}

const onOpened = ({ button }) => () => {
  button.focus();
}

const setRef = ({ setButton, button }) => ref => {
  if (!button) {
    setButton(ref);
  }
}

const ConnectedPageErrorModal = props => {
  const {
    onLocalClose,
    onLocalDisconnect,
    data: {
      company_name: companyName,
      created_at: createdAt,
      user_name: userName,
      errorMessage,
    },
    setRef,
    closeModal,
  } = props;

  if (errorMessage) {
    return (
      <div className="connected-page-error-modal">
        <ModalBody className="connected-page-error-modal__body">
          <div className="connected-page-error-modal__description">
            {errorMessage}
          </div>
          <div className="connected-page-error-modal__action-block">
            <Button
              className="connected-page-error-modal__button"
              onClick={closeModal}
            >
              Ok
            </Button>
          </div>
        </ModalBody>
      </div>
    );
  }

  const formattedDate = moment(createdAt).format('MMMM Do, YYYY');

  return (
    <div className="connected-page-error-modal">
      <ModalHeader
        className="connected-page-error-modal__header"
        toggle={onLocalClose}
      >
        Facebook Page already in use
      </ModalHeader>
      <ModalBody className="connected-page-error-modal__body">
        <div className="connected-page-error-modal__description">
          This Facebook Page is in use by someone else&apos;s Customers.ai
          account.
          <span className="connected-page-error-modal__highlighted">
            We recommend you contact this person before disconnecting the
            Facebook page from their Customers.ai account.
          </span>
          If you believe this is an error, please contact support@customers.ai.
        </div>
        <div className="connected-page-error-modal__info-block">
          <div className="connected-page-error-modal__info">
            <span className="connected-page-error-modal__info-label">
              Page in account:
            </span>
            {companyName}
          </div>
          <div className="connected-page-error-modal__info">
            <span className="connected-page-error-modal__info-label">
              Page connected by:
            </span>
            {userName}
          </div>
          <div className="connected-page-error-modal__info">
            <span className="connected-page-error-modal__info-label">
              Page connected on:
            </span>
            {formattedDate}
          </div>
        </div>
        <div className="connected-page-error-modal__action-block">
          <Button
            className="connected-page-error-modal__button"
            invert
            red
            onClick={onLocalDisconnect}
          >
            Disconnect Page
          </Button>
          <Button
            innerRef={ref => setRef(ref)}
            className="connected-page-error-modal__button"
            onClick={onLocalClose}
          >
            Ok
          </Button>
        </div>
      </ModalBody>
    </div>
  );
}

const enhance = compose(
  withState('button', 'setButton', null),
  withHandlers({ onLocalClose, onLocalDisconnect, onOpened, setRef }),
);

export default enhance(ConnectedPageErrorModal);
